import { apiSlice } from 'state/slices/apiSlice';

const TEAMS_URL = '/teams';

export const teamApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createTeam: builder.mutation({
      query: (teamData) => ({
        url: `${TEAMS_URL}/create`,
        method: 'POST',
        body: teamData,
        transformResponse: (response) => response.json(),
      }),
    }),
    getTeams: builder.query({
      query: () => `${TEAMS_URL}/list`,
    }),
    updateTeam: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `${TEAMS_URL}/update`,
          method: 'PUT',
          body: { id, ...data },
        };
      },
    }),
    deleteTeam: builder.mutation({
      query: (id) => ({
        url: `${TEAMS_URL}/delete`,
        method: 'DELETE',
        body: { id },
      }),
    }),
  }),
});

export const {
  useCreateTeamMutation,
  useGetTeamsQuery,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
} = teamApiSlice;
